module.exports = __webpack_public_path__ + "img/Zasilanie placu miejskiego1.5383c123.jpg";